module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/bed-alt.svg?bd0ec9ee172c10e2db3cebdcc368121b";